import { BadgeCheck } from "lucide-react";
import { normalizeContractorName } from "@/utils/urlUtils";

interface ContractorHeaderProps {
  name: string;
  serviceType: string;
  city: string;
  featured: boolean;
}

export const ContractorHeader = ({ name, serviceType, city, featured }: ContractorHeaderProps) => {
  const displayName = normalizeContractorName(name);
  
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <h1 className="text-3xl font-bold">{displayName}</h1>
        {featured && (
          <div className="flex items-center gap-1 bg-green-500 text-white px-2 py-0.5 rounded-full text-xs font-medium">
            <BadgeCheck className="h-3.5 w-3.5" />
            <span>Verified Pro</span>
          </div>
        )}
      </div>
      <h2 className="text-lg text-muted-foreground">
        {serviceType} in {city}, OK
      </h2>
    </div>
  );
};